import React, { useRef, useState } from "react";
import Webcam from "react-webcam";
import { FaCamera, FaUser, FaTimes, FaRedo } from "react-icons/fa";
import "./CameraCapture.css";

const CameraCapture = ({ image, setImage, onCapture }) => {
  const webcamRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);

  const openCamera = () => {
    setShowCamera(true);
  };

  const closeCamera = () => {
    const tracks = webcamRef.current?.stream?.getTracks();
    if (tracks) tracks.forEach(track => track.stop());
    setShowCamera(false);
  };

  const capture = () => {
    if (!webcamRef.current) return;
    const screenshot = webcamRef.current.getScreenshot();
    setImage(screenshot);
    setShowCamera(false);

    const tracks = webcamRef.current?.stream?.getTracks();
    if (tracks) tracks.forEach(track => track.stop());

    if (onCapture) {
      onCapture(screenshot);
    }
  };

  const retake = () => {
    setImage(null);
    setShowCamera(true);
  };

  return (
    <div className="profile-photo-container">
      <div className="profile-photo-ring" onClick={openCamera} title="Click to Capture Patient Photo">
        <div className="avatar-preview-box">
          {image && !showCamera ? (
            <img src={image} alt="Patient Avatar" className="captured-avatar-img" />
          ) : (
            <div className="empty-avatar-placeholder">
              <FaUser size={36} color="#94a3b8" />
            </div>
          )}
        </div>

        <div className="camera-badge-trigger">
          <FaCamera size={13} color="#ffffff" />
        </div>
      </div>

      <span className="avatar-hint-text">
        {image ? 'Patient Photo Captured' : 'Click to Capture Photo'}
      </span>

      {image && !showCamera && (
        <button className="retake-pill-btn" onClick={retake}>
          <FaRedo size={11} /> Retake Photo
        </button>
      )}

      {/* Webcam Dialog Modal Overlay */}
      {showCamera && (
        <div className="camera-modal-backdrop">
          <div className="camera-modal-card">
            <div className="camera-modal-header">
              <div className="header-title-group">
                <div className="header-icon-badge">
                  <FaCamera size={14} color="#2563eb" />
                </div>
                <div>
                  <h3>Patient Photo Studio</h3>
                  <span className="header-subtitle">Align face inside the target circle</span>
                </div>
              </div>
              <button className="modal-close-btn" onClick={closeCamera} title="Close Camera">
                <FaTimes size={15} />
              </button>
            </div>

            <div className="camera-feed-box">
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                className="webcam-stream"
                videoConstraints={{ width: 360, height: 360, facingMode: "user" }}
              />
              <div className="face-guide-circle">
                <div className="guide-target-ring"></div>
              </div>
            </div>

            <div className="camera-modal-actions">
              <button className="capture-snap-btn" onClick={capture}>
                <FaCamera size={14} /> Snap Photo
              </button>
              <button className="cancel-modal-btn" onClick={closeCamera}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CameraCapture;
